import request from '@/utils/request';
//临时变量条件列表
export function getTvfRuleList(param) {
  return request('/decision/variable-input', {
    method: 'GET',
    params: param,
  });
}
//新增临时变量条件
export function addTvfRuleList(values) {
  return request('/decision/variable-input', {
    method: 'POST',
    data: values,
  });
}
//删除临时变量条件
export function deleteTvfRuleList(values) {
  const { id } = values || {};
  return request(`/decision/variable-input/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
//保存所有临时变量条件
export function saveTvfRuleList(values) {
  return request('/decision/variable-input/saveAll', {
    method: 'POST',
    data: values,
  });
}
//编辑输出列表
export function editOutputList(values) {
  const { ruleOutputId } = values || {};
  values['ruleOutputId'] = undefined;
  return request(`/decision/rule/rule-output-item/${ruleOutputId}`, {
    method: 'PUT',
    data: values,
  });
}

//新增输出列表
export function addOutputList(values) {
  return request('/decision/rule/rule-output-item', {
    method: 'POST',
    data: values,
  });
}
//删除输出列表
export function deleteOutputList(values) {
  const { id } = values || {};
  return request(`/decision/rule/rule-output-item/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
//规则列表
export function getRuleList(param) {
  return request('/decision/rule/combine-relation', {
    method: 'GET',
    params: param,
  });
}
//保存单一规则列表
export function saveRuleList(values) {
  return request('/decision/rule/combine-relation/single', {
    method: 'POST',
    data: values,
  });
}
//
export function saveMultipleRuleList(values) {
  return request('/decision/rule/combine-relation/multiple', {
    method: 'POST',
    data: values,
  });
}
//删除规则列表
export function deleteRuleList(values) {
  const { id } = values || {};
  return request(`/decision/rule/combine-relation/regularExpression/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
//删除规则列表多个
export function deleteMulRuleList(values) {
  const { relationId } = values || {};
  return request(`/decision/rule/combine-relation/${relationId}`, {
    method: 'DELETE',
    // data: values,
  });
}
// 操作日志
export function getHandleList(param) {
  return request('/decision/variable-input/log', {
    method: 'GET',
    params: param,
  });
}
